var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedallaRetos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 40.727,
    viewBox: "0 0 32 40.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "medal-default",
    d: "M21,2A15.979,15.979,0,0,1,32.636,28.953V39.818a2.905,2.905,0,0,1-4.364,2.516L21,38.131l-7.273,4.2a2.909,2.909,0,0,1-4.364-2.516V28.953A15.979,15.979,0,0,1,21,2ZM34.091,18A13.091,13.091,0,1,0,21,31.091,13.111,13.111,0,0,0,34.091,18ZM12.273,39.833,21,34.785l8.727,5.047V31.411a15.929,15.929,0,0,1-17.455,0Zm1.876-19.476.087-.524h.058l-.378-.378-2.153-2.109a2.9,2.9,0,0,1,1.6-4.96l2.982-.436.524-.073.233-.48L18.44,8.691a2.907,2.907,0,0,1,5.207,0L24.985,11.4l.233.48.524.073,2.982.436a2.9,2.9,0,0,1,1.6,4.96l-2.153,2.109-.378.378.087.524.509,2.967a2.939,2.939,0,0,1-1.164,2.851,2.924,2.924,0,0,1-3.069.218L21.495,25l-.48-.247-.48.247-2.662,1.4a2.924,2.924,0,0,1-3.069-.218,2.91,2.91,0,0,1-1.164-2.851Zm4.611-5.8-2.051.291h.029l-2.982.436,2.153,2.109,1.484,1.44-.349,2.036-.509,2.967,2.662-1.4,1.833-.96,1.833.96,2.662,1.4-.509-2.967-.349-2.036,1.484-1.44L28.3,15.28l-2.982-.436-2.051-.291-.916-1.847L21.015,10l-1.338,2.705Z",
    transform: "translate(-5 -2)",
    fill: "#003865",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedallaRetos);
export default __webpack_public_path__ + "static/media/medalla-retos.fe831b6c3eb9f7a68018a3932bc20e0c.svg";
export { ForwardRef as ReactComponent };